// extracted by mini-css-extract-plugin
export default {"wrapper":"InputNumber_wrapper__rF8TO","button":"InputNumber_button__fzU-X","right":"InputNumber_right__BPWqP","input":"InputNumber_input__r96No"};